import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Typography, TextField, Box } from '@mui/material';

import { AppContext } from 'AppContext';
import ModalDialog from '@/components/ModalDialog/ModalDialog';

const BuyOptionsPack = ({ packs, accountId }) => {
  const appContext = useContext(AppContext);
  const { name: packName } = useParams();
  const [count, setCount] = useState('1');
  const [validCount, setValidCount] = useState(true);

  if (!packs || !packName || !packs[packName]) {
    return null;
  }

  const pack = packs[packName];

  const onCountChange = event => {
    let newVal = event.target.value;
    let number = parseInt(newVal);
    if (isNaN(number)) {
      newVal = '';
      setValidCount(false);
    } else if (number < 1) {
      newVal = '0';
      setValidCount(false);
    } else {
      newVal = number;
      setValidCount(true);
    }
    setCount(newVal);
  };

  const digitFilter = e => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const buy = () => {
    if (!validCount) {
      return;
    }
    const origin = window.location.origin;
    appContext.tBankPaymentApi
      .tbankBuyPack(accountId, {
        packId: packName,
        count: parseInt(count),
        successUrl: `${origin}/app/profile/account?payment=success`,
        failUrl: `${origin}/app/profile/account/buy-pack-error/${packName}`,
      })
      .then(res => {
        window.location.href = res.data.paymentUrl;
      })
      .catch(() => {
        appContext.history.push('/profile/account/buy-pack-error/' + packName);
      });
  };

  const totalCount = (count || 0) * pack.amount;
  const totalPrice = (count || 0) * pack.price;

  return (
    <ModalDialog
      title='Купить пакет'
      size='sm'
      okButtonText='Оплатить'
      handleClose={() => appContext.history.push('/profile/account')}
      handleOk={buy}
    >
      <Typography sx={{ textAlign: 'center', fontSize: 16, color: '#37474F', mb: 3 }}>
        {pack.description}
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Typography component='label' htmlFor='count' sx={{ flex: '0 0 50%', fontSize: 15 }}>
          Количество пакетов:
        </Typography>
        <TextField
          id='count'
          variant='outlined'
          size='small'
          type='number'
          value={count}
          onChange={onCountChange}
          onKeyPress={digitFilter}
          error={!validCount}
          helperText={!validCount && 'Минимум 1'}
          sx={{ flex: '0 0 50%' }}
          inputProps={{ min: 1, style: { height: 26, padding: '10px 15px' } }}
        />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Typography sx={{ flex: '0 0 50%', fontSize: 15 }}>
          Количество{pack.limit === 'deskPerDay' && ' стоек'}:
        </Typography>
        <Typography sx={{ flex: '0 0 50%', fontSize: 15, fontWeight: 'bold' }}>
          {totalCount}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Typography sx={{ flex: '0 0 50%', fontSize: 15, fontWeight: 'bold' }}>
          Стоимость:
        </Typography>
        <Typography sx={{ flex: '0 0 50%', fontSize: 15, fontWeight: 'bold' }}>
          {totalPrice} руб.
        </Typography>
      </Box>
    </ModalDialog>
  );
};

export default BuyOptionsPack;
